document.addEventListener("DOMContentLoaded", () => {
  const collapsibles = document.querySelectorAll(".pdp-collapsible-item");

  collapsibles.forEach((item) => {
    const summary = item.querySelector("summary");
    const content = item.querySelector(".collapsible-content");

    // If item is open by default, show properly
    if (item.hasAttribute("open")) {
      content.style.maxHeight = "none";
      content.style.opacity = "1";
    }

    summary.addEventListener("click", (e) => {
      e.preventDefault();

      if (item.hasAttribute("open")) {
        closeCollapsible(item, content);
      } else {
        openCollapsible(item, content);
      }
    });
  });

  function openCollapsible(item, content) {
    item.setAttribute("open", "true");
    const height = content.scrollHeight + "px";

    content.style.maxHeight = "0";
    content.style.opacity = "0";
    requestAnimationFrame(() => {
      content.style.maxHeight = height;
      content.style.opacity = "1";
    });

    content.addEventListener("transitionend", function handler() {
      content.style.maxHeight = "none";
      content.removeEventListener("transitionend", handler);
    });
  }

  function closeCollapsible(item, content) {
    const height = content.scrollHeight + "px";

    content.style.maxHeight = height;
    content.style.opacity = "1";

    requestAnimationFrame(() => {
      content.style.maxHeight = "0";
      content.style.opacity = "0";
    });

    content.addEventListener("transitionend", function handler() {
      item.removeAttribute("open");
      content.removeEventListener("transitionend", handler);
    });
  }
});
